<template>
  <div class="brand_page">
    <div class="dp_1" :style="{ backgroundImage: 'url(' + imgSiteNum0 + ')' }">
      <div class="dp_11">
        <p class="dp_1_1">{{ siteNum0 }}</p>
        <p class="dp_1_2">
          {{ siteNum1 }}
        </p>
      </div>
    </div>
    <div class="dp_2">
      <moduleTitle :title="siteNum2"></moduleTitle>
      <brandDynamic
        v-if="brandDynamics && brandDynamics.length > 0"
        :brandDynamics="brandDynamics"
      ></brandDynamic>
      <noData v-if="brandDynamics && brandDynamics.length == 0"></noData>
    </div>
  </div>
</template>

<script>
import moduleTitle from "./component/moduleTitle.vue";
import brandDynamic from "./component/brandDynamic.vue";
import noData from "./component/noData.vue";
export default {
  name: "brand_page",
  props: ["langType"],
  watch: {
    langType: function (type) {
      this.changeLang(type);
    },
  },
  components: {
    moduleTitle,
    brandDynamic,
    noData,
  },
  mounted: function () {
    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.changeLang('zh')
    }else{
      this.changeLang('en')
    }
    // this.changeLang(this.$i18n.locale);
    this.getImg();

    this.$post("/halababy/loofox/brand", { type: 1 }).then((res) => {
      if (res.status == 200) {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i]["image"] = this.$ip + res.data[i]["image"];
        }
        this.brandDynamics = res.data;
      } else {
      }
    });
  },
  methods: {
    //修改语言
    changeLang(type) {
      this.$post("/halababy/loofox/text", { pageNum: 5 }).then((res) => {
        if (type == "zh") {
          this.siteNum0 = res.data[0]["content"];
          this.siteNum1 = res.data[1]["content"];
          this.siteNum2 = res.data[2]["content"];
        } else {
          this.siteNum0 = res.data[0]["contentEn"];
          this.siteNum1 = res.data[1]["contentEn"];
          this.siteNum2 = res.data[2]["contentEn"];
        }
      });
    },
    getImg() {
      this.$post("/halababy/loofox/img", { pageNum: 5 }).then((res) => {
        this.imgSiteNum0 = this.$ip + res.data[0]["imgUrl"];
      });
    },
  },
  data() {
    return {
      brandDynamics: this.brandDynamics,
      siteNum0: this.siteNum0,
      siteNum1: this.siteNum1,
      siteNum2: this.siteNum2,
      imgSiteNum0: this.imgSiteNum0,
    };
  },
};
</script>

<style>
.brand_page {
  width: 100%;
  margin-bottom: 80px;
}
.dp_1 {
  width: 100%;
  height: 238px;
}
.dp_11 {
  width: 1200px;
  height: 100%;
  margin: auto;
}
.dp_1_1 {
  /* width: 400px; */
  padding-top: 35px;
  font-size: 48px;
  font-family: sucaijishikufangti;
  font-weight: 400;
  color: #ffffff;
  text-shadow: 0px 4px 6px rgba(14, 176, 223, 0.2);
  text-align: left;
  margin: 0;
}
.dp_1_2 {
  /* width: 700px; */
  /* letter-spacing: 37px; */
  padding-top: 20px;
  text-align: left;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 34px;
  opacity: 0.8;
}
.dp_2 {
  width: 1200px;
  margin: 30px auto 0 auto;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/brand.vue